import request from '../utils/request';

/**
 * publish api function
 */
export const publishAPI = (data: Object = {}) => request({
  url: '/api/v1/publishApi',
  method: 'POST',
  data,
});

/**
 *
 * query all api
 * */

export const queryAllApi = () => request({
  url: '/api/v1/queryAllApi',
  method: 'GET',
});

/**
 * query api detail
 */

export const queryApiDetail = (apiId:any = '') => request({
  url: `/api/v1/queryApiDetail/${apiId}`,
  method: 'GET',
});
